import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { URL_CHECK, URL_CHECK_COLORS } from '../../config/const.config';

const HealthCheckLabel = ({ value }) => {
  const label = URL_CHECK[value] || 'Unknown';
  const color = URL_CHECK_COLORS[value] || 'primary';

  return (
    <Chip
      label={label}
      color={color}
      variant="filled"
      size="small"
      sx={{ fontSize: 11, height: 20 }}
    />
  );
};

HealthCheckLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default HealthCheckLabel;
